/**
 * Component gut-projects-filtered-carousel JS
 *
 * !!! Uncomment only if component is needed, this way the compiler will ignore useless files
 */
 
jQuery(document).ready(function () {
    const component = jQuery('.gut-projects-filtered-carousel');

    if (!component.length) {
        return;
    }

    jQuery('.gut-projects-filtered-carousel .gut-projects-filtered-carousel__carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        //
        dots: true,
        //
        arrows: true,
        prevArrow: jQuery('.gut-projects-filtered-carousel__top-arrows-prev a'),
        nextArrow: jQuery('.gut-projects-filtered-carousel__top-arrows-next a'),
        //
        infinite: true,
        autoplay: false,
        //
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
        ]
    });
});